import React from "react";
import embassy from "../images/venue/icons/new/embassy.png";
import mine from "../images/venue/icons/new/mine.png";
import maze from "../images/venue/icons/new/maze.png";
import lockhart88 from "../images/venue/icons/new/lockhart88.png";
import port from "../images/venue/icons/new/port.png";
import zinc from "../images/venue/icons/zinc.png";
import taboo from "../images/venue/icons/new/taboo.png";
import graffiti from "../images/venue/icons/new/graffiti.png";
import gate from "../images/venue/icons/new/gate.png";
import thestation from "../images/venue/icons/new/thestation.png";
import centrico from "../images/venue/icons/new/centrico.png";

const Venue = (props) => {
  return (
    <>
      <div className="container aboutContainer">
        <div className="row venueDiv col-12 text-center">
          <h6>OUR VENUES</h6>
          <div className="venueLogoIcon col-6 col-md-1">
            <a href="https://embassy.zincgroup.com.hk" target="_blank" rel="noreferrer"><img src={embassy} alt="embassy" /></a>
          </div>
          <div className="venueLogoIcon col-6 col-md-1">
            <a href="https://mine.zincgroup.com.hk" target="_blank" rel="noreferrer"><img src={mine} alt="mine" /></a>
          </div>
          <div className="venueLogoIcon col-6 col-md-1">
            <a href="https://maze.zincgroup.com.hk" target="_blank" rel="noreferrer"><img src={maze} alt="maze" /></a>
          </div>
          <div className="venueLogoIcon col-6 col-md-1">
            <a href="https://lockhart88.zincgroup.com.hk" target="_blank" rel="noreferrer"><img src={lockhart88} alt="lockhart88" /></a>
          </div>
          <div className="venueLogoIcon col-6 col-md-1">
            <a href="https://port.zincgroup.com.hk" target="_blank" rel="noreferrer"><img src={port} alt="port" /></a>
          </div>
          <div className="venueLogoIcon col-6 col-md-1">
            <a href="https://taboo.zincgroup.com.hk" target="_blank" rel="noreferrer"><img src={taboo} alt="taboo" /></a>
          </div>
          {/* GRAFFITI hidden
          <div className="venueLogoIcon col-6 col-md-1">
            <a href="https://graffiti.zincgroup.com.hk" target="_blank" rel="noreferrer"><img src={graffiti} alt="graffiti" /></a>
          </div>
          */}
          <div className="venueLogoIcon col-6 col-md-1">
            <a href="https://gate.zincgroup.com.hk" target="_blank" rel="noreferrer"><img src={gate} alt="gate" /></a>
          </div>
          <div className="venueLogoIcon col-6 col-md-1">
            <a href="https://thestation.zincgroup.com.hk" target="_blank" rel="noreferrer"><img src={thestation} alt="the station" /></a>
          </div>
          <div className="venueLogoIcon col-6 col-md-1">
            <a href="https://centrico.zincgroup.com.hk" target="_blank" rel="noreferrer"><img src={centrico} alt="centrico" /></a>
          </div>
        </div>
        <div className="row about col-12 text-center m-0">
          <h6>ABOUT US</h6>
          {<pre className="about-top-description" dangerouslySetInnerHTML={{ __html: props.about }}></pre>}
        </div>
      </div>
    </>
  );
};

export default Venue;
